import React from "react";
import { useSnapshot } from "valtio";
import { templateStore } from "@pages/Applications/C&C/C&CSetup/templateStore";
import { NoPicture } from "@components/Common/SvgIcons";
import { baseURL } from "../Website/constants";

type ImageDisplayProps = {
    item: any;
    width?: string | number;
    height?: string | number;
    isApp?: boolean;
    asBackground?: boolean;
    children?: React.ReactNode;
};

export function ImageDisplay({
    item,
    width = "100%",
    height = "100%",
    isApp = false,
    asBackground = false,
    children,
}: ImageDisplayProps) {
    const snap = useSnapshot(templateStore);

    const getImageUrl = React.useCallback(() => {
        if (!item?.Url) return "";
        if (
            item.Url.startsWith("http") ||
            item.Url.startsWith("https") ||
            item.Url.startsWith("blob:")
        ) {
            return item.Url;
        }
        return `${baseURL}/${snap.iuud}/${item.Url}`;
    }, [item?.Url, snap.iuud]);

    const videoStyle = {
        width,
        height,
        objectFit: "fill" as const,
        borderRadius: isApp ? "10px" : "0px",
    };
    const imageStyle = {
        width,
        height,
        objectFit: "fill" as const,
        borderRadius: isApp ? "10px" : "0px",
    };

    const backgroundStyle = {
        backgroundImage: `url(${getImageUrl()})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        width,
        height,
        borderRadius: isApp ? "10px" : "0px",
    };

    if (
        Object.keys(item || {}).length === 0 ||
        Object.values(item || {}).every((el) => !el)
    ) {
        return <NoPicture height={250} width={width} />;
    }

    if (asBackground) {
        return <div style={backgroundStyle}>{children}</div>;
    }

    return item?.Type?.toLowerCase().includes("video") ? (
        <video autoPlay muted loop style={videoStyle}>
            <source src={getImageUrl()} type="video/mp4" />
        </video>
    ) : (
        <img
            src={getImageUrl()}
            alt={item?.Name || "Preview"}
            style={imageStyle}
        />
    );
}
